// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "(max-width: 768px)";
var _4 = "wrapper-3EEyY";
var _5 = "header-3gqqG";
export { _1 as "__esModule", _2 as "mobile", _3 as "tabletMiddle", _4 as "wrapper", _5 as "header" }
export default { "__esModule": _1, "mobile": _2, "tabletMiddle": _3, "wrapper": _4, "header": _5 }
